import React, { useState, useEffect, useMemo } from "react";
import { Switch } from "antd";
import axios from "axios";
import classNames from 'classnames';

// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import { Drawer, CardMedia, Typography, Box, InputLabel, Select, OutlinedInput, MenuItem, Chip, FormControl } from '@mui/material';

// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Button from "components/CustomButtons/Button.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";
import { Form } from "react-bootstrap";
import { FaFileCsv } from "react-icons/fa";

import Search from "@material-ui/icons/Search";
import CustomInput from "components/CustomInput/CustomInput.js";
import SomeSpinner from "components/Somespinner/Somespinner.js";

import TableOrderOperator from "components/TableOrderOperator/TableOrderOperator";

import api from "assets/services/api.js";
import useAuth from "hooks/useAuth";
import { grayColor } from "assets/jss/material-dashboard-react.js";
import GetAppIcon from "@material-ui/icons/GetApp";

import styles5 from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import styles6 from "assets/jss/material-dashboard-react/components/sidebarStyle.js";

const styles3 = {
    amountbox: {
        fontSize: "14px",
    },
    MT: {
        marginTop: "-18px",
    },
};

const styles4 = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0",
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF",
        },
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1",
        },
    },
    colorCard: {
        color: "#999",
        marginTop: "10px",
        marginBottom: "-1em",
        fontSize: "12px",
    },
    floatRight: {
        float: "right",
    },
    maxwidht: {
        maxWidth: "107%",
    },
    toogleclass: {
        marginTop: "15px",
        marginBottom: "15px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50",
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)",
    },
    zindex: {
        zIndex: "0 !important",
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px",
    },
    cardCategory: {
        color: grayColor[0],
        margin: "0",
        fontSize: "7px",
        marginTop: "0",
        paddingTop: "0px",
        marginBottom: "0",
    },
    sizeAmount: {
        fontSize: "20px",
    },
    marginFor: {
        marginTop: "-10px",
    },
    fontSizeOf: {
        fontSize: "10px",
    },
    marg: {
        float: "left",
    },
    List: {
        border: "1px solid #d9dddd",
    },
    mgTop: {
        marginTop: "12px",
        float: "left",
        position: "relative",
        marginLeft: "3px",
    },
    tp: {
        marginTop: "10px",
    },
    center: {
        position: "relative",
        marginLeft: "auto",
        marginRight: "auto",
    },
};

const useStyles4 = makeStyles(styles4);
const useStyles5 = makeStyles(styles5);
const useStyles6 = makeStyles(styles6);

const useStyles3 = makeStyles(styles3);
const useStyles2 = makeStyles(styles2);
const useStyles = makeStyles(styles);


export default function Order() {
    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    };

    const classes = useStyles();
    const classes2 = useStyles2();
    const classes3 = useStyles3();
    const classes4 = useStyles4();
    const classes5 = useStyles5();
    const classes6 = useStyles6();

    const { storageId, garlicType, user } = useAuth();
    const [ordersChecked, setOrdersChecked] = useState([]);
    const [loading, setLoading] = useState(false);
    //data api
    const [ordersBase, setOrdersBase] = useState([]);
    const [sellsmans, setSellsmans] = useState([]);
    //orders
    const [sellsmansChoose, setSellsmansChoose] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [search, setSearch] = useState("");
    const [toogle, setToggle] = useState(false);
    const [toogleCancel, setToogleCancel] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [batchs, setBatchs] = useState([]);
    const [batchChoose, setBatchChoose] = useState(1);
    const [stateRefresh, setStateRefresh] = useState(false);
    const [productsPerBox, setProductsPerBox] = useState([]);
    const [sum, setSum] = useState();
    const [weight, setWeight] = useState(0);
    const [orders, setOrders] = useState([]);
    const [storageOfProducts, setStorageOfProducts] = useState([{ id: 1, new_code: 11 }]);
    useEffect(() => {
        loadOrders();
    }, [startDate, page, endDate, toogle, toogleCancel, garlicType]);
    useEffect(() => {
        if (stateRefresh) {
            loadOrders();
            setStateRefresh(false);
        }
    }, [ordersChecked]);
    useEffect(() => {
        ordersSellsmanFilter();
    }, [ordersBase, sellsmansChoose])
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            loadOrders();
        }, 900);
        return () => clearTimeout(delayDebounceFn);
    }, [search]);
    useEffect(() => {
        getStoragesOfProducts();
        getAllBatchs();
    }, []);
    async function loadSellsman() {
        const response = await api.get('sellsman/admin/type/all/' + storageId)
        setSellsmans(response.data);
    };
    const toogler = () => {
        setPage(1);
        setToggle(!toogle);
    };
    const tooglerCancel = () => {
        setToogleCancel(!toogleCancel);
    };
    const ordersSellsmanFilter = () => {
        if (sellsmansChoose.length !== 0) {
            let filter_orders = [];
            sellsmansChoose.forEach(sellsman => {
                const filter = ordersBase.filter(order => order.id_sellsman === sellsman.id);
                filter_orders = [...filter_orders, ...filter]
            });
            setOrders(filter_orders);
        } else {
            setOrders(ordersBase);
        }
    };
    async function getStoragesOfProducts() {
        if (garlicType === true) {
            const response = await api.get("/product_client/operator/orders/garlic/" + storageId);
            let aux = [];
            for (let i = 0; i < response.data.length; i++) {
                response.data[i].newAmount = response.data[i].amountWithoutSell;
                response.data[i].newBox = response.data[i].box;
                aux.push({
                    id_product: response.data[i].id_product,
                    name: response.data[i].name,
                    amount: 0,
                    weight: 0,
                    box: response.data[i].box,
                });
            }
            setProductsPerBox(aux);
            setStorageOfProducts(response.data);
        } else {
            const response = await api.get("/product_client/operator/orders/" + storageId);
            let aux = [];
            for (let i = 0; i < response.data.length; i++) {
                response.data[i].newAmount = response.data[i].amountWithoutSell;
                response.data[i].newBox = response.data[i].box;
                aux.push({
                    id_product: response.data[i].id_product,
                    name: response.data[i].name,
                    amount: 0,
                    weight: 0,
                    box: response.data[i].box,
                });
            }
            setProductsPerBox(aux);
            setStorageOfProducts(response.data);
        }

    }

    const handleChange = (event, value) => {
        setPage(value);
    };

    async function loadOrders() {
        const response = await api.get(`/order/view/${storageId}?&type=operator&page=${page}&date_init=${startDate}&date_end=${endDate}&control=${toogle}&cancel=${toogleCancel}&search=${search}&garlic=${garlicType}`);
        if (toogle) {
            setOrdersBase(response.data.orders);
            setTotalPages(response.data.totalPages);
        } else if (toogleCancel) {
            setOrdersBase(response.data.orders);
            setTotalPages(response.data.totalPages);
        } else {
            if (page === 1 && ordersChecked.length === 0) {
                setOrdersBase(response.data.orders);
            } else if (ordersChecked.length > 0) {
                let orders_response = response.data.orders;
                ordersChecked.forEach(order => {
                    orders_response = orders_response.filter((order_response) => order.order_controller != order_response.order_controller);
                });
                let orders_out_checker = orders;
                ordersChecked.forEach(order => {
                    orders_out_checker = orders_out_checker.filter((order_response) => order.order_controller != order_response.order_controller);
                });
                setOrdersBase((prevOrders) => [...ordersChecked, ...orders_out_checker, ...orders_response]);
            } else {
                setOrdersBase((prevOrders) => [...prevOrders, ...response.data.orders]);
            }
            setTotalPages(response.data.totalPages);
        };
    };
    async function handlePushOrders() {
        setPage(page + 1);
    }
    async function handleInvoiceOrder() {
        let ord = [];

        setLoading(true);
        ordersChecked.forEach(order => {
            for (let j = 0; j < order.products.length; j++) {
                if (order.products[j].checked) {
                    ord.push(order.products[j].id);
                }
            }
        });

        if (ord.length === 0) {
            setLoading(false);
            alert("Selecione os pedidos a serem faturados");
        }

        const batch = await api.get("/batch/operator/generate/" + storageId);
        let control = false;

        for (let i = 0; i < storageOfProducts.length; i++) {
            if (
                parseFloat(storageOfProducts[i].amountWithOrder2) < 0 ||
                parseFloat(storageOfProducts[i].newAmount) < 0
            ) {
                control = true;
                break;
            }
        }
        if (control && storageId === 3) {
            alert("Estoque insuficiente");
            setLoading(false);
        } else {
            const response = await api.put(`/order/new/${storageId}`, {
                id_orders: ord,
                batch: batch.data,
            });
            if (response.status === 200) {
                setStateRefresh(true);
                setOrdersChecked([]);
                setLoading(false);
                setPage(1);
                getAllBatchs();
                setWeight(0);
            } else {
                setLoading(false);
                alert("Erro ao faturar pedidos, tente novamente");
            }
        }
    }

    async function getAllBatchs() {
        const response = await api.get("/batch/operator/" + storageId);
        setBatchs(response.data);
        if (response.data.length > 0) {
            setBatchChoose(response.data[0].batch);
        }
    }

    async function download() {
        await api
            .get("/order/create/pdf/operator/" + storageId + "/" + batchChoose + '?garlic=' + garlicType, {
                responseType: "blob",
            })
            .then(function (response) {
                let blob = new Blob([response.data], {
                    responseType: "arraybuffer",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/pdf",
                    },
                });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                switch (storageId) {
                    case 3:
                        link.download = "Pedidos do lote " + batchChoose + " RJ.pdf";
                        break;
                    case 6:
                        link.download = "Pedidos do lote " + batchChoose + " GO.pdf";
                        break;
                    case 7:
                        link.download = "Pedidos do lote " + batchChoose + " PR.pdf";
                        break;
                    case 8:
                        link.download = "Pedidos do lote " + batchChoose + " BA.pdf";
                        break;
                    case 10:
                        link.download = "Pedidos do lote " + batchChoose + " SP.pdf";
                    case 9:
                        link.download = "Pedidos do lote " + batchChoose + " AP.pdf";
                        break;
                    case 11:
                        link.download = "Pedidos do lote " + batchChoose + " SE.pdf";
                        break;
                    case 12:
                        link.download = "Pedidos do lote " + batchChoose + " GR.pdf";
                        break;
                    default:
                        link.download = "Pedidos do lote " + batchChoose + " .pdf";
                        break;
                }
                link.click();
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    async function downloadCsv() {
        const response = await api.get("/create/csv/operator/" + storageId);

        if (response.data) {
            await api
                .get("/create/csv/download/operator/" + storageId, { responseType: "blob" })
                .then(function (response) {
                    let blob = new Blob([response.data], {
                        responseType: "arraybuffer",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/pdf",
                        },
                    });
                    let link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "Pedidos.csv";
                    link.click();
                })
                .catch(function (error) {
                    console.log(error);
                });
        } else {
            alert("Não foi possível efetuar o download");
        }
    }

    async function calculateWeight(ord_amount, ord_weight, id_prod, somate) {
        const index_prod = productsPerBox.findIndex(prodPerBox => prodPerBox.id_product === id_prod);
        const index_prod_storage = storageOfProducts.findIndex(prodStorage => prodStorage.id_product === id_prod);
        const weight2 = parseFloat(ord_amount) * parseFloat(ord_weight)
        if (somate) {
            storageOfProducts[index_prod_storage].newAmount =
                storageOfProducts[index_prod_storage].newAmount - parseFloat(ord_amount);
            storageOfProducts[index_prod_storage].amountWithOrder2 =
                storageOfProducts[index_prod_storage].amountWithOrder2 - parseFloat(ord_amount);
            storageOfProducts[index_prod_storage].boxWithOrder =
                parseFloat(storageOfProducts[index_prod_storage].amountWithOrder2) /
                parseFloat(storageOfProducts[index_prod_storage].box);

            productsPerBox[index_prod].amount += parseFloat(ord_amount);
            productsPerBox[index_prod].weight += weight2;
            setWeight((weight) => weight + weight2);
        } else {
            storageOfProducts[index_prod_storage].newAmount =
                storageOfProducts[index_prod_storage].newAmount + parseFloat(ord_amount);
            storageOfProducts[index_prod_storage].amountWithOrder2 =
                storageOfProducts[index_prod_storage].amountWithOrder2 + parseFloat(ord_amount);
            storageOfProducts[index_prod_storage].boxWithOrder =
                parseFloat(storageOfProducts[index_prod_storage].amountWithOrder2) /
                parseFloat(storageOfProducts[index_prod_storage].box);

            productsPerBox[index_prod].amount -= parseFloat(ord_amount);
            productsPerBox[index_prod].weight -= weight2;
            setWeight((weight) => weight - weight2);
        };


    };



    function getDataOfTable() {
        let teste = [];

        for (let i = 0; i < productsPerBox.length; i++) {
            teste[i] = [];

            teste[i].push(productsPerBox[i].name);
            if (productsPerBox[i].amount % productsPerBox[i].box === 0) {
                teste[i].push(
                    productsPerBox[i].amount / parseFloat(productsPerBox[i].box) +
                    " caixas"
                );
            } else {
                if (productsPerBox[i].amount / productsPerBox[i].box > 1) {
                    const str = (
                        productsPerBox[i].amount / productsPerBox[i].box
                    ).toString();
                    const splitted = str.split(".");

                    const int = parseInt(splitted[0]);
                    const decimal = parseInt(splitted[1]);
                    teste[i].push(
                        int +
                        " caixas e " +
                        parseInt(parseFloat("0." + decimal) * parseInt(productsPerBox[i].box)) +
                        " soltos"
                    );
                } else {
                    teste[i].push(productsPerBox[i].amount + " soltos");
                }
            }

            teste[i].push(parseFloat(productsPerBox[i].weight).toFixed(2) + "kg");
            if (i === productsPerBox.length - 1) {
                teste[i + 1] = [];
                teste[i + 1].push("Total");
                teste[i + 1].push(sum);
                teste[i + 1].push(weight + "kg");
            }
        }
        return teste;
    }

    const handleCheckedAll = (index) => {

        // Verifica se o pedido atual está em ordersChecked
        const isOrderChecked = ordersChecked.some(order => order.order_controller === orders[index].order_controller);
        let totalChecked = 0;
        orders[index].products.forEach(prod => {
            if (prod.checked) {
                totalChecked += 1;
            }
        });
        if (totalChecked < orders[index].products.length) {
            orders[index].checked = true;
            orders[index].products.forEach((prod, i) => {
                // somatoria de produto quando ja tiver alguns selecionados (+)
                if (!orders[index].products[i].checked) {
                    calculateWeight(orders[index].products[i].amount, orders[index].products[i].weight, orders[index].products[i].id_product, true);
                }
                prod.checked = true;
            });
            setOrdersChecked(prevOrdersChecked => [...prevOrdersChecked, orders[index]]);
        } else if (isOrderChecked) {
            // Se o pedido já está em ordersChecked, removemos o pedido de ordersChecked
            setOrdersChecked(prevOrdersChecked => prevOrdersChecked.filter(order => order.order_controller !== orders[index].order_controller));

            // Desmarcamos o pedido e todos os seus produtos
            orders[index].checked = false;
            orders[index].products.forEach((prod, i) => {
                prod.checked = false;
                // somatoria de produto quando ja tiver todos selecionados (-)

                if (!prod.checked) {
                    calculateWeight(orders[index].products[i].amount, orders[index].products[i].weight, orders[index].products[i].id_product, false);
                };
            });
        } else {
            orders[index].checked = true;
            orders[index].products.forEach((prod, i) => {
                prod.checked = true;
                // somatoria de produto quando ja tiver todos selecionados (+)
                if (prod.checked) {
                    calculateWeight(orders[index].products[i].amount, orders[index].products[i].weight, orders[index].products[i].id_product, true);
                }
            });
            setOrdersChecked(prevOrdersChecked => [...prevOrdersChecked, orders[index]]);
        }
    };

    const handleChecked = async (index_order, index_prod) => {
        let updatedOrdersChecked = [...ordersChecked]; // Copia o estado atual de ordersChecked

        // Altera o estado do produto selecionado
        orders[index_order].products[index_prod].checked = !orders[index_order].products[index_prod].checked;
        if (orders[index_order].products[index_prod].checked) {
            calculateWeight(orders[index_order].products[index_prod].amount, orders[index_order].products[index_prod].weight, orders[index_order].products[index_prod].id_product, true);
        } else {
            calculateWeight(orders[index_order].products[index_prod].amount, orders[index_order].products[index_prod].weight, orders[index_order].products[index_prod].id_product, false);
        };
        // Verifica se algum produto no pedido está marcado
        let control = orders[index_order].products.some(product => product.checked);

        if (control) {
            orders[index_order].checked = true;
            // Se pelo menos um produto está marcado, primeiro removemos o pedido de ordersChecked (se estiver presente)
            updatedOrdersChecked = updatedOrdersChecked.filter(order => order.order_controller !== orders[index_order].order_controller);
            // Em seguida, adicionamos o pedido a ordersChecked
            updatedOrdersChecked.push(orders[index_order]);
        } else {
            // Se nenhum produto está marcado, removemos o pedido de ordersChecked
            updatedOrdersChecked = updatedOrdersChecked.filter(order => order.order_controller !== orders[index_order].order_controller);
        }

        // Atualiza o estado de ordersChecked
        setOrdersChecked(updatedOrdersChecked);
    };
    const handleChangeSellsman = (event) => {
        const {
            target: { value },
        } = event;
        setSellsmansChoose(
            typeof value === 'string' ? value.split(',') : value,
        );
    };
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    function getProductImage(code) {
        try {
            return require(`assets/img/products/${code}.png`);
        } catch (err) {
            return require(`assets/img/products/11.png`);
        }
    }
    return (
        <>
            <GridContainer>

                <>
                    <Drawer
                        anchor="right"
                        variant="permanent"
                        open
                        classes={{
                            paper: classNames({
                                [classes6.drawerPaperRTL]: true,
                            }),
                        }}
                    >
                        {storageOfProducts.map((product, index) => (
                            <Box
                                key={`${index}`}
                                sx={{
                                    minWidth: '20em',
                                    border: '1px solid black',
                                    backgroundColor: product.amountWithOrder2 < 0 ? "#f5b1ac" : "white"
                                }}
                            >
                                <CardMedia sx={{ marginTop: '0.5em' }}>
                                    <img
                                        className={classes.imageOrder}
                                        src={getProductImage(product.new_code)}
                                        title={product.name}
                                        alt={product.name} />
                                </CardMedia>
                                <Typography component="div" >
                                    {`${product.amountWithoutSell}  <==>  ${product.newAmount}`}
                                    <div>
                                        Caixas: {product.boxWithouSell}
                                    </div>
                                </Typography>
                                <Typography component="div" >
                                    Com pedidos:
                                    <div>
                                        {`${product.amountWithOrder}  <==>  ${product.amountWithOrder2}`}
                                    </div>
                                    <div>
                                        Caixas: {parseFloat(product.boxWithOrder)}
                                    </div>
                                </Typography>
                            </Box>
                        ))}
                    </Drawer>
                </>
                <GridItem xs={12} sm={6} md={2}>
                    <Card className={classes4.marginFor}>
                        <div className="d-flex justify-content-center">
                            <p className={classes4.colorCard}>
                                Clique abaixo para inserir <b>filtro</b> de data primária
                            </p>
                        </div>
                        <div className="d-flex justify-content-center">
                            <DatePicker
                                className={classes4.marginDate + " " + classes4.zindex}
                                selected={startDate}
                                onChange={(date) =>
                                    date ? setStartDate(date.withoutTime()) : setStartDate(null)
                                }
                                dateFormat="dd/MM/yyyy"
                                placeholderText="Digite ou clique aqui"
                                disabledKeyboardNavigation
                                locale={pt}
                            />
                        </div>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={6} md={2}>
                    <Card className={classes4.marginFor}>
                        <div className="d-flex justify-content-center">
                            <p className={classes4.colorCard}>
                                Clique abaixo para inserir <b>filtro</b> de data secundária{" "}
                            </p>
                        </div>
                        <div className="d-flex justify-content-center">
                            <DatePicker
                                className={classes4.marginDate}
                                selected={endDate}
                                onChange={(date) =>
                                    date ? setEndDate(date.withoutTime()) : setEndDate(null)
                                }
                                dateFormat="dd/MM/yyyy"
                                placeholderText="Digite ou clique aqui"
                                disabledKeyboardNavigation
                                locale={pt}
                            />
                        </div>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={6} md={1}>
                    <Card className={classes4.marginFor}>
                        <div className="d-flex justify-content-center">
                            <p className={classes4.colorCard}>
                                <b>filtro</b> para faturados
                            </p>
                        </div>
                        <div className="d-flex justify-content-center">
                            <Switch className={classes4.toogleclass} onClick={() => toogler()} />
                        </div>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={6} md={1}>
                    <Card className={classes4.marginFor}>
                        <div className="d-flex justify-content-center">
                            <p className={classes4.colorCard}>
                                <b>filtro</b> de cancelados
                            </p>
                        </div>
                        <div className="d-flex justify-content-center">
                            <Switch className={classes4.toogleclass} onClick={() => tooglerCancel()} />
                        </div>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={6} md={1}>
                    <Card className={classes4.marginFor}>
                        <div className="d-flex justify-content-center">
                            <p className={classes4.colorCard}>Lote faturado</p>
                        </div>
                        <div className="d-flex justify-content-center">
                            <div className={classes4.mgTop}>
                                <Form.Control
                                    onChange={(event) => setBatchChoose(event.target.value)}
                                    value={batchChoose}
                                    as="select"
                                >
                                    {batchs.map((batch, index) => (
                                        <option key={String(index)} value={batch.batch}>
                                            {batch.batch}
                                        </option>
                                    ))}
                                </Form.Control>
                            </div>
                            <div className={classes4.mgTop}>
                                <Tooltip
                                    id="tooltip-top"
                                    title={"Download lote"}
                                    placement="top"
                                    classes={{ tooltip: classes2.tooltip }}
                                >
                                    <IconButton
                                        aria-label="Done"
                                        className={classes2.tableActionButton}
                                        onClick={() => download()}
                                    >
                                        <GetAppIcon
                                            className={
                                                classes2.tableActionButtonIconDownload +
                                                " " +
                                                classes2.edit4 +
                                                " " +
                                                classes4.tp
                                            }
                                        />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </div>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={6} md={1}>
                    <Card className={classes4.marginFor}>
                        <div className="d-flex justify-content-center">
                            <p className={classes4.colorCard}>Pedidos atuais</p>
                        </div>
                        <div className="d-flex justify-content-center">
                            <div className={classes4.mgTop}>
                                <Tooltip
                                    id="tooltip-top"
                                    title={"Download csv"}
                                    placement="top"
                                    classes={{ tooltip: classes2.tooltip }}
                                >
                                    <IconButton
                                        aria-label="Done"
                                        className={classes2.tableActionButton}
                                        onClick={() => downloadCsv()}
                                    >
                                        <FaFileCsv
                                            className={
                                                classes2.tableActionButton + " " + classes2.edit4
                                            }
                                        />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </div>
                    </Card>
                </GridItem>
                <GridItem xs={6} sm={6} md={1}  >
                    <Card className={classes4.marginFor} >
                        <div className="d-flex justify-content-center">
                            <p className={classes4.colorCard}>Vendedores</p>
                        </div>
                        <div className="d-flex justify-content-center">
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <InputLabel id="demo-multiple-chip-label">Filtro Vendedor</InputLabel>
                                <Select
                                    labelId="demo-multiple-chip-label"
                                    id="demo-multiple-chip"
                                    multiple
                                    value={sellsmansChoose}
                                    onChange={handleChangeSellsman}
                                    input={<OutlinedInput id="select-multiple-chip" label="vendedor" />}
                                    renderValue={(selected) => (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {selected.map((value, index) => (
                                                <Chip key={index} label={value.name} />
                                            ))}
                                        </Box>
                                    )}
                                    MenuProps={MenuProps}
                                >
                                    {sellsmans.map((sellsman) => (
                                        <MenuItem
                                            key={sellsman.id}
                                            value={sellsman}
                                        >
                                            {sellsman.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </Card>
                </GridItem>
                <div className={classes4.zindex}>
                    <GridItem xs={12} sm={12} md={9}>
                        <div className={classes5.searchWrapper}>
                            <CustomInput
                                formControlProps={{
                                    className: classes5.margin + " " + classes5.search,
                                }}
                                inputProps={{
                                    placeholder: "Busca por pedido, razão social ou nome fantasia",
                                    inputProps: {
                                        "aria-label": "Search",
                                        type: "text",
                                        value: search,
                                        onChange: (event) => setSearch(event.target.value),
                                    },
                                }}
                            />
                            <Button color="white" aria-label="edit" justIcon round>
                                <Search />
                            </Button>
                        </div>
                    </GridItem>
                </div>
                {
                    orders.map((order, index) =>
                    (
                        <TableOrderOperator
                            key={`${index}`}
                            order={order}
                            ordersChecked={ordersChecked}
                            indexOfOrder={index}
                            loadOrders={loadOrders}
                            handleChecked={(index_order, index_prod, id) => handleChecked(index_order, index_prod, id)}
                            handleCheckedAll={(index_order, index_prod) => handleCheckedAll(index_order)}
                            toogle={toogle}
                            toogleCancel={toogleCancel}
                        />
                    )
                    )
                }
                <GridItem xs={12} sm={12} md={10}>
                    {loading ? (
                        <div>
                            <SomeSpinner />
                        </div>
                    ) : (
                        <div></div>
                    )}
                    {toogle || toogleCancel ? (
                        <Pagination count={totalPages} page={page} onChange={(e, value) => handleChange(e, value)} />
                    ) : (
                        <div>
                            {totalPages > 1 && totalPages != page ? (
                                <div className="d-flex justify-content-center">
                                    <div className={classes2.marginT}>
                                        <Tooltip
                                            id="tooltip-top"
                                            title={"Descer"}
                                            placement="top"
                                            classes={{ tooltip: classes2.tooltip }}
                                        >
                                            <IconButton
                                                aria-label="Done"
                                                className={classes2.tableActionButton}
                                                onClick={() => handlePushOrders()}
                                            >
                                                <KeyboardArrowDownIcon
                                                    className={
                                                        classes2.tableActionButtonIconArrow +
                                                        " " +
                                                        classes2.edit3
                                                    }
                                                />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                </div>
                            ) : (
                                <div></div>
                            )}
                            <div className="d-flex justify-content-center">
                                <Button color="success" onClick={handleInvoiceOrder}>
                                    Faturar pedidos selecionados
                                </Button>
                            </div>
                            <Card >
                                <Table
                                    tableHeaderColor="primary"
                                    tableHead={["Produtos", "Quantidade", "Peso"]}
                                    tableData={getDataOfTable()}
                                />
                            </Card>
                        </div>
                    )}
                </GridItem>
            </GridContainer >
        </>
    );
}
